




import Vue from 'vue'
import style from './style.module.scss'

export default Vue.extend({
    name: 'loader',
    components: {

    },
    props: {

    },
    data() {
        return {
            style: style
        }
    },
})
